import * as React from "react";
const SvgFlashOn = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 2V13H10V22L17 10H13L17 2H7Z", fill: "currentColor" }));
export default SvgFlashOn;
